// Load JSON from firebase storage
const firebase = require("firebase/app");
require("firebase/storage");

const fetchFirebaseJson = async (name) => {
  return new Promise((resolve, reject) => {
    let storage = firebase.storage();
    let jsonRef = storage.ref(`json/${name}.json`);
    jsonRef
      .getDownloadURL()
      .then((url) => {
        fetch(url)
          .then((data) => data.json())
          .then((json) => resolve(json))
          .catch((err) => reject(err));
      })
      .catch((err) => reject(err));
  });
};

const jsonLoader = async (name) => {
  return new Promise((resolve, reject) => {
    fetchFirebaseJson(name)
      .then((data) => {
        if (data == null || data.content == null) {
          reject(
            "Error while parsing JSON file",
            name,
            ". It does not exist or migth be badly formatted."
          );
        }
        resolve(data.content);
      })
      .catch((err) => reject(err));
  });
};

export default jsonLoader;
